import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "purchasePrice",
    "mortgageRate",
    "loanAmount",
    "loanTerm",
    "propertyTaxes",
    "homeInsurance",
    "estimatedPayment",
  ];

  connect() {
    this.PROPERTY_TAX_RATE = 0.0125;
    this.HOME_INSURANCE_RATE = 0.003;
    this.calculateEstimatedPayment();
  }

  calculateEstimatedPayment() {
    const purchasePrice =
      parseFloat(this.purchasePriceTarget.value.replace(/[^0-9.-]+/g, "")) || 0;
    const mortgageRate =
      parseFloat(this.mortgageRateTarget.value.replace(/[^0-9.-]+/g, "")) || 0;
    const loanAmount =
      parseFloat(this.loanAmountTarget.value.replace(/[^0-9.-]+/g, "")) || 0;
    const loanTermYears = parseInt(this.loanTermTarget.value, 10);
    const propertyTaxes = purchasePrice * this.PROPERTY_TAX_RATE;
    const homeInsurance = purchasePrice * this.HOME_INSURANCE_RATE;

    this.propertyTaxesTarget.value = `$${propertyTaxes.toFixed(0)}`;
    this.homeInsuranceTarget.value = `$${homeInsurance.toFixed(0)}`;

    const monthlyRate = mortgageRate / 12 / 100;
    const totalPayments = loanTermYears * 12;
    const numerator = monthlyRate * Math.pow(1 + monthlyRate, totalPayments);
    const denominator = Math.pow(1 + monthlyRate, totalPayments) - 1;
    const monthlyMortgagePayment = loanAmount * (numerator / denominator);
    const monthlyPropertyTaxes = propertyTaxes / 12;
    const monthlyHomeInsurance = homeInsurance / 12;
    const totalMonthlyPayment =
      monthlyMortgagePayment + monthlyPropertyTaxes + monthlyHomeInsurance;

    this.estimatedPaymentTarget.textContent = `$${totalMonthlyPayment.toFixed(0)}`;
  }
}
